import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {first} from 'rxjs';
function getErrorList(form: FormGroup): {field: string; errors: string[]}[] {
  const fields = Object.keys(form.controls);

  return fields.reduce((arr: {field: string; errors: string[]}[], field) => {
    const fc = form.get(field);

    const errors = fc?.errors;
    if (errors) {
      arr.push({field: field, errors: Object.keys(errors)});
    }
    return arr;
  }, []);
}

export function formGroupValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fg = control as FormGroup;
    const fields = Object.keys(fg.controls);
    const list: Record<string, string[]> = {};
    fields.forEach((field) => {
      const fc = fg.get(field);

      if (fc?.errors && fc?.touched) {
        list[field] = Object.keys(fc?.errors);
      } else {
        fc?.statusChanges.pipe(first()).subscribe((el) => {
          // list[field] = Object.keys(fc?.errors ?? {});
          if (fc.touched) {
            fc.updateValueAndValidity();
          }
        });
      }
    });

    return Object.keys(list).length > 0 ? list : null; //errArr.length > 0 ? {valid: errArr} : null;
  };
}
